import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useInView } from "../../../hooks/useInView";
import { BANNER_BLOCK_EVENT } from "../../../store/blocks/infoCards/constants";
import { sendBlockBannerAnalytics } from "../../analytics";
import { getAlreadyIncludes, getCurrentViewBanner } from "../utils";
export var useViewportCarouselAnalytics = function useViewportCarouselAnalytics(_ref) {
  var banners = _ref.banners,
    currentBanner = _ref.currentBanner,
    pageType = _ref.pageType,
    ref = _ref.ref;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    viewedList = _useState2[0],
    setViewedList = _useState2[1];
  var inView = useInView(ref, {
    threshold: 0.5
  });
  var currentIndex = currentBanner - 1;
  var maxLengthBanners = banners === null || banners === void 0 ? void 0 : banners.length;
  var alreadyIncludes = getAlreadyIncludes({
    currentBanner: currentBanner,
    maxLengthBanners: maxLengthBanners,
    viewedList: viewedList
  });
  var _getCurrentViewBanner = getCurrentViewBanner({
      banners: banners,
      currentBanner: currentBanner,
      currentIndex: currentIndex,
      maxLengthBanners: maxLengthBanners,
      viewedList: viewedList
    }),
    id = _getCurrentViewBanner.id,
    link = _getCurrentViewBanner.link,
    title = _getCurrentViewBanner.title;
  useEffect(function () {
    if (alreadyIncludes) {
      return;
    }
    if (inView) {
      sendBlockBannerAnalytics({
        event: BANNER_BLOCK_EVENT.view,
        id: id,
        name: title,
        pageType: pageType,
        url: link
      });
      setViewedList([].concat(_toConsumableArray(viewedList), [id]));
    }
  }, [inView, currentBanner, alreadyIncludes, viewedList]);
};